// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-toastify/dist/ReactToastify.css';

// eslint-disable-next-line import/no-extraneous-dependencies
import { toast, ToastContainer } from 'react-toastify';

// Reusable toast function with dynamic progress bar color
export const showToast = (message, type = 'default', options = {}) => {
  // Add null safety check
  if (!message) {
    console.warn('showToast called with empty message');
    return null;
  }

  // Define colors for progress bar based on toast type
  const getProgressBarColor = (toastType) => {
    switch (toastType) {
      case 'success':
        return '#28a745'; // Green for success
      case 'error':
        return '#dc3545'; // Red for error
      case 'info':
        return '#17a2b8'; // Blue for info
      case 'warn':
        return '#ffc107'; // Yellow for warning
      default:
        return '#28a745'; // Default blue
    }
  };

  try {
    const defaultOptions = {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      progressStyle: {
        backgroundColor: getProgressBarColor(type), // Set the progress bar color dynamically
      },
      ...options,
    };

    // Handle toast type based on the 'type' parameter
    switch (type) {
      case 'success':
        return toast.success(message, defaultOptions);
      case 'error':
        return toast.error(message, defaultOptions);
      case 'info':
        return toast.info(message, defaultOptions);
      case 'warn':
        return toast.warn(message, defaultOptions);
      default:
        return toast.success(message, defaultOptions);
    }
  } catch (error) {
    console.error('Error showing toast:', error);
    return null;
  }
};

// ToastContainer setup
export const ToastContainerStyled = () => (
  <ToastContainer
    limit={5} // Limit the number of toasts visible at once
  />
);
